"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _productContent = _interopRequireDefault(require("../../../common/product-content"));
var _quantitySelector = _interopRequireDefault(require("@ux/quantity-selector"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _tracking = require("@site/pattern-library-utils/tracking");
var _functions = require("../../../utils/functions");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _configContext = require("../../../context/config-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const StyledQuantitySelector = /*#__PURE__*/(0, _react2.styled)(_quantitySelector.default)({
  name: "StyledQuantitySelector",
  class: "pc-srgj6zr"
});
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-c9ayfq2"
});
const modifySelector = "pc-mhyc5pp";
const QtySelectorTrackingProxy = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "QtySelectorTrackingProxy",
  class: "pc-q1aima2j"
});
const isValidInteger = (str, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) => {
  const num = Number(str);
  return !isNaN(num) && Number.isInteger(num) && num >= min && num <= max;
};

/**
 * QuantitySelectorRow Component
 *
 * @param {Object} props React props
 * @param {number} props.initialValue Initial value for the quantity
 * @param {function} props.handleChange Function to handle quantity change
 * @param {number} props.min Minimum value for the quantity
 * @param {number} props.max Maximum value for the quantity
 * @param {string} props._name Name of the component
 * @param {Object} [props.rest] Additional props
 * @returns {React.ReactElement} QuantitySelectorRow Component
 * @public
 */
function QuantitySelectorRow({
  initialValue = 1,
  handleChange,
  min = 1,
  max = 300,
  _name = 'quantity_selector',
  product,
  instancePath,
  helpMessage,
  isAddon,
  ...rest
}) {
  const qtySelectorId = 'default-quantity-selector';
  const {
    configData
  } = (0, _configContext.useConfig)();
  const [value, setValue] = (0, _react.useState)(initialValue);
  const currentProduct = product || '';
  const trackingData = (0, _tracking.create)(`${currentProduct}_${_name}_${initialValue}`, true, false);

  // Memoize addon detection to avoid repeated parsing
  const addonInfo = (0, _react.useMemo)(() => {
    const [productName, displayArea, itemName] = (0, _functions.parseInstancePath)(instancePath);
    return {
      productName,
      displayArea,
      itemName
    };
  }, [instancePath]);
  (0, _react.useEffect)(() => {
    if (value === '') {
      return;
    }
    if (configData?.instance) {
      let storedQuantity;

      // Check if this is an addon quantity selector
      if (isAddon) {
        // Addon quantity selector - get from customData
        const customData = configData.instance[addonInfo.productName]?.[addonInfo.displayArea]?.[addonInfo.itemName]?.customData;
        // eslint-disable-next-line no-undefined
        storedQuantity = customData ? parseInt(customData, 10) : undefined;
      } else {
        // Main product quantity selector
        storedQuantity = configData.instance[currentProduct]?.properties?.quantity;
      }

      // eslint-disable-next-line no-undefined
      if (storedQuantity !== undefined && storedQuantity !== value) {
        setValue(storedQuantity);
      }
    }
  }, [configData, value, currentProduct, addonInfo]);
  const handleQuantityChange = newValue => {
    const isEmptyStr = newValue === '';
    if (!isValidInteger(newValue, min, max)) {
      if (isEmptyStr) {
        setValue(newValue);
      }
      return;
    }
    setValue(newValue);

    // Determine if this is an addon quantity selector and pass appropriate parameters
    handleChange(newValue, currentProduct, isAddon ? instancePath : null);
    trackingData?.ref?.current?.click();
  };
  const handleBlur = () => {
    if (value === '') {
      handleQuantityChange(min);
    }
  };
  (0, _react.useEffect)(() => {
    (0, _tracking.updateTracking)(trackingData?.ref?.current, `${currentProduct}_${_name}_${value}`);
  }, [value, currentProduct, _name, trackingData]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "quantity-selector",
    "data-partial": "precheck"
  }, /*#__PURE__*/_react.default.createElement(_productContent.default, rest), /*#__PURE__*/_react.default.createElement(QtySelectorTrackingProxy, trackingData), /*#__PURE__*/_react.default.createElement(StyledQuantitySelector, {
    size: 2,
    id: qtySelectorId,
    value: value,
    min: min,
    max: max,
    onChange: handleQuantityChange,
    onBlur: handleBlur,
    className: modifySelector,
    helpMessage: helpMessage
  }));
}
var _default = exports.default = QuantitySelectorRow;
QuantitySelectorRow.propTypes = {
  initialValue: _propTypes.default.number,
  handleChange: _propTypes.default.func,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  _name: _propTypes.default.string,
  product: _propTypes.default.string,
  instancePath: _propTypes.default.string,
  helpMessage: _propTypes.default.string,
  isAddon: _propTypes.default.bool
};